<template>
  <div class="btn-group w-100">
    <button
      class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
      data-bs-auto-close="outside" aria-expanded="false"
    >
      {{ $t("selecioneUmServico", servicos.length, { count: servicos.length }) }}
    </button>
    <ul class="dropdown-menu">
      <li class="dropdown-item">
        <a class="dropdown-item">
          <div class="form-check">
            <input
              id="checkAllServicos" class="form-check-input" type="checkbox"
              :checked="servicos.length == servicoArray.length" @input="onCheckedAllServicos"
            >
            <label class="form-check-label w-100" for="checkAllServicos">{{ $t("todos") }}</label>
          </div>
        </a>
      </li>
      <li v-for="(servico, index) in servicoArray" :key="index" class="dropdown-item">
        <a class="dropdown-item">
          <div class="form-check">
            <input
              :id="'checku' + index" v-model="servicos" class="form-check-input" :value="servico.id"
              type="checkbox"
            >
            <label class="form-check-label w-100" :for="'checku'+index">{{ servico.nome }}</label>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { getServicos } from '@/modules/shared/listService';

export default {
  props: {
    modelValue: { type: Array, required: true },
  },
  emits: ['update:modelValue'],
  data: (props) => ({
    servicos: props.modelValue,
    servicoArray: [],
  }),

  watch: {
    servicos() {
      this.$emit('update:modelValue', this.servicos);
    },
  },
  async mounted() {
    await this.getServicosFilter();
    this.onCheckedAllServicos();
  },

  methods: {
    async getServicosFilter() {
      this.servicoArray = await getServicos();
    },
    onCheckedAllServicos() {
      this.servicos =
        this.servicos.length === this.servicoArray.length ? [] : this.servicoArray.map((servico) => servico.id);
    },
  },
};
</script>
